import axios from '@/axios';

const RESOURCE_NAME = '/needs';

export default {
    createNeed(need) {
        return axios.post(`${RESOURCE_NAME}/create-need`, {need});
    },

    getIndexList() {
        return axios.get(`${RESOURCE_NAME}/get-index-list`)
    },

    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`)
    },

    getOnboardingStep() {
        return axios.get(`${RESOURCE_NAME}/get-onboarding-step`)
    },

    saveOnboardingStep(step) {
        return axios.post(`${RESOURCE_NAME}/save-onboarding-step`, {step})
    },
}
